import React from "react";
import PropTypes from "prop-types";

export default function Fail(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M84 168C130.392 168 168 130.392 168 84C168 37.6081 130.392 0 84 0C37.6081 0 0 37.6081 0 84C0 130.392 37.6081 168 84 168Z"
        fill="#F3F6FA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.131 124.661L117.931 121.423L84.4643 87.5489L47.2389 124.331L44 121.131L47.2389 117.931L81.2665 84.3122L44.3307 46.927L47.8307 44L84.503 81.1145L121.734 44.3307L124.661 47.8307L87.7008 84.3509L124.331 121.423L121.131 124.661Z"
        fill="#E46262"
      />
    </svg>
  );
}

Fail.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
Fail.defaultProps = {
  className: "",
  width: 168,
  height: 168
};
